import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-201f5de0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Log out ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Settings ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_popover = _resolveComponent("ion-popover")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_button, { id: "trigger-button" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_icon, {
          slot: "start",
          icon: $setup.personCircleOutline
        }, null, 8, ["icon"])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_popover, {
      trigger: "trigger-button",
      "show-backdrop": "false",
      "dismiss-on-select": "true"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  button: "",
                  onClick: $setup.store.signUserOut
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: $setup.logOutOutline
                    }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_ion_item, {
                  button: "",
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push('/tabs/settings')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: $setup.settingsOutline
                    }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}